import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";import clsx from 'clsx';
import Button from "../Button";
import React, { useEffect, useState } from 'react';

import CompareCard from "./CompareCard";
import { createStyles } from "./styles";

var ComparisonBlock = function ComparisonBlock(_ref)





{var comparedPortfolios = _ref.comparedPortfolios,onRemoveFromComparison = _ref.onRemoveFromComparison,hideCompareBlock = _ref.hideCompareBlock,compareSelectedPortfolios = _ref.compareSelectedPortfolios,_ref$compareBlockStyl = _ref.compareBlockStyles,compareBlockStyles = _ref$compareBlockStyl === void 0 ? '' : _ref$compareBlockStyl;
  var classes = createStyles();
  var _useState = useState(false),_useState2 = _slicedToArray(_useState, 2),isCompareBlockShown = _useState2[0],setIsCompareBlockShown = _useState2[1];

  // does not update state without checking the list length in useEffect
  useEffect(function () {
    if (comparedPortfolios.length > 0) setIsCompareBlockShown(true);
    if (comparedPortfolios.length === 0) setIsCompareBlockShown(false);
  }, [comparedPortfolios.length]);

  var comparedCards = _mapInstanceProperty(comparedPortfolios).call(comparedPortfolios, function (card) {
    return /*#__PURE__*/(
      React.createElement(CompareCard, { key: card.id, card: card, onRemoveFromComparison: onRemoveFromComparison }));

  });

  var onComparisonBlockCancel = function onComparisonBlockCancel() {
    setIsCompareBlockShown(false);
    hideCompareBlock();
  };

  return /*#__PURE__*/(
    React.createElement(React.Fragment, null,
    isCompareBlockShown && /*#__PURE__*/
    React.createElement("div", { className: clsx(classes.comparisonBlock, compareBlockStyles) }, /*#__PURE__*/
    React.createElement("p", { className: classes.compareTitle }, "Compare Plans:"), /*#__PURE__*/
    React.createElement("div", { className: classes.comparedCardsList }, comparedCards), /*#__PURE__*/
    React.createElement("div", { className: classes.buttonsBlock }, /*#__PURE__*/
    React.createElement(Button, {
      type: "outlined",
      color: "primary",
      onClick: onComparisonBlockCancel,
      className: classes.cancelButton }, "Cancel"), /*#__PURE__*/



    React.createElement(Button, { color: "primary", onClick: compareSelectedPortfolios }, "Compare Plans")))));







};

export default ComparisonBlock;
//# sourceMappingURL=index.js.map